<section [style]="styles">
  @if (labelEnabled) {
    <blaze-element-label
      [color]="props?.style?.general?.title?.color1"
      [extendInputPadding]="elementContext?.extendInputPadding"
      [fontFamily]="props?.style?.labelBlock?.fontFamily"
      [fontSize]="props?.style?.labelBlock?.fontSize"
      [fontStyle]="props?.style?.labelBlock?.fontStyle"
      [fontWeight]="props?.style?.labelBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.labelBlock?.iconSize"
      [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
      [lineHeight]="props?.style?.labelBlock?.lineHeight"
      [position]="props?.content?.title?.position"
      [tooltip]="props?.content?.title?.tooltip"
      [width]="props?.content?.title?.width"
      class="flex-shrink-0"
      verticalAlign="top"
    >
      {{ labelText }}
    </blaze-element-label>
  }
  <div class="input-wrapper" [style]="inputWrapperStyles">
    <blaze-scroller class="scroller">
      @switch (mode) {
        @case ('text') {
          <ng-container *ngTemplateOutlet="textTpl" />
        }
        @case ('image') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
        @case ('box') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
        @case ('chip') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
        @case ('card') {
          <ng-container *ngTemplateOutlet="imageTpl" />
        }
      }
    </blaze-scroller>
  </div>
</section>

@if (hasValidationError) {
  <div class="validation" [style]="validationStyles">
    {{ formState?.messages?.required || formState?.messages?.invalid || '' }}
  </div>
}

<ng-template #textTpl>
  <mat-radio-group
    class="input"
    [style]="inputWrapperStyles"
    [class.validation-error]="hasValidationError"
    [class.readonly]="isReadOnly"
    [value]="selected?.[valueField]"
    (change)="onSelectionChanged($event)"
  >
    @for (opt of displayedOptions; track opt) {
      <mat-radio-button
        [style]="inputWrapperStyles"
        disableRipple
        class="{{ elementKeyRoot }} {{ elementKey }}"
        [value]="opt[valueField]"
        >{{ opt | optionLabel: labelField }}
      </mat-radio-button>
    }
  </mat-radio-group>
</ng-template>

<ng-template #imageTpl>
  @if (!!displayedOptions) {
    <blaze-item-selector
      [ngClass]="{
        'tile-group': true,
        'validation-error': hasValidationError,
        'flex-1': layout === 'column',
      }"
      [options]="displayedOptions"
      [selected]="selectedOptions"
      [isReadOnly]="isReadOnly"
      itemClass="flex-shrink-0 max-w-full"
      [containerClass]="{
        'tile-group-container': true,
        'align-columns': layout === 'column',
      }"
      (selectedChange)="selectOption($event)"
    >
      <ng-template let-option let-selected="selected">
        <blaze-selectable-tile
          [style]="tileStyles"
          [labelStyles]="labelStyles"
          [class.selected-tile]="selected"
          [selected]="selected"
          [showCheckmark]="showCheckmark"
          [imageSrc]="option[imageField]"
          [showImage]="showImage"
          [icon]="option[iconField]"
          [showIcon]="showIcon"
          [imageSettings]="imageSettings"
          [iconSettings]="iconSettings"
          [labelPosition]="imagePosition"
          [tileAlign]="cardAlign"
          [label]="option | optionLabel: labelField"
          [mode]="mode"
          [subLabel]="mode === 'box' ? option[boxSubTextField] : undefined"
          [subLabelStyles]="subTextStyles"
          [cardContent]="cardContentForOption()(option)"
          [cardStyles]="(cardStyles$ | async) || undefined"
          [isReadOnly]="isReadOnly"
        />
      </ng-template>
    </blaze-item-selector>
  }
</ng-template>
